module.exports = __webpack_public_path__ + "static/media/ichiko.6cf86911.png";